module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAICAYAAABatbkrAAAAeElEQVRIS+1VQQ7AIAjr/v9mYIHh7Fiy8w49mAoWFYL1CPdABPZwwNNOnPPlm2jNTb8h7MKKN0YD1tqnv3nFmTFk0/7BvLo3nb3sxDuv5pTd+WYdirPrcahAKhB1tzpoP209safGSYNKhIdoS6T1i727grvkB9/8CWFLlqVPSDinAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/subtitle/bar.png
// module id = emp2
// module chunks = 1